import {ASSET_DETAIL, ASSET_LIST} from '@constants/internal-route.constant'
import {IAppRoutes} from '@interface/common.interface'
import {guard} from './route-guard'

export const AssetRoutes: IAppRoutes = {
  link: ASSET_LIST,
  childrens: [
    {
      link: ASSET_LIST,
      element: guard(() => import('@modules/asset/Asset'), [ASSET_LIST]),
    },
    {
      link: ASSET_DETAIL({id: ':id'}),
      element: guard(() => import('@modules/asset/Asset/Detail'), [ASSET_LIST]),
    },
  ],
}
